<div id="politica-privacidade" class="container">
  <div class="row">
    <div class="col-12 mt-4 ms-4">
      <a routerLink="/login" class="btn btn-success">Voltar para login</a>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="card card-root">
        <div class="card-header">
          Política de Privacidade
        </div>
        <div class="card-body">
          <iframe
            [src]="pdfUrl"
            class="pdf-frame"
          >
          </iframe>
        </div>
      </div>
    </div>
  </div>
</div>
